import { Row, Typography } from "antd";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import useInfiniteScroll from "react-infinite-scroll-hook";
import { useDispatch } from "react-redux";
import { REQUEST_LOADING_STATES } from "../../../helpers/constant";
import useFetchPublicCollections from "../../../hooks/collectionHooks/useFetchPublicCollections";
import { getPublicCollections } from "../../../redux/collections/collectionsSlice";
import { AppDispatch } from "../../../redux/store";
import SpinnerComponent from "../../SpinnerComponent/SpinnerComponent";
import CollectionItem from "./CollectionItem";
import "./index.less";

type CollectionGridProps = {
  creatorId: string;
  showModal: () => void;
  goToPublicationTab?: () => void;
  profileName?: string;
  username?: string;
};

const CollectionPublicGridComponent: React.FC<CollectionGridProps> = ({ creatorId, showModal, goToPublicationTab, profileName, username }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch<AppDispatch>();
  const { publicCollections, loading, shouldNavigateToPublicationPage } = useFetchPublicCollections(creatorId);

  useEffect(() => {
    if (shouldNavigateToPublicationPage) {
      goToPublicationTab && goToPublicationTab();
    }
  }, [shouldNavigateToPublicationPage, goToPublicationTab]);

  const loadMoreCollections = () => {
    if (publicCollections?.hasMore && loading !== REQUEST_LOADING_STATES.PENDING && creatorId) {
      dispatch(getPublicCollections({ creatorId, page: publicCollections.page }));
    }
  };
  const [sentryRef] = useInfiniteScroll({
    loading: loading === REQUEST_LOADING_STATES.PENDING,
    hasNextPage: publicCollections?.hasMore || false,
    onLoadMore: loadMoreCollections,
  });

  return (
    <Row className="custom-spacing" gutter={4}>
      {publicCollections?.collections.length === 0 && loading === REQUEST_LOADING_STATES.SUCCEEDED && (
        <Row className="w-full justify-content-center mt-50">
          <Typography.Text className="font-16-bold text-white-color">{t("no-collection-at-the-moment")}</Typography.Text>
        </Row>
      )}
      {publicCollections?.collections.map((collection, index) => (
        <CollectionItem
          key={index}
          collection={collection}
          handleNavigation={showModal}
          profileName={profileName}
          username={username}
          index={index}
        />
      ))}
      {(loading === REQUEST_LOADING_STATES.PENDING || publicCollections?.hasMore) && (
        <Row className="w-full justify-content-center mt-20">
          <SpinnerComponent refProp={sentryRef} />
        </Row>
      )}
    </Row>
  );
};

export default CollectionPublicGridComponent;
